import Heading4 from "../Heading/Heading4";
import ButtonPrimaryOutline from "../Button/ButtonPrimaryOutline";
import ButtonPrimary from "../Button/ButtonPrimary";
import React, { useContext, useState } from "react";
import { currencyFormatter } from "../../utils/format";
import PaymentContext from "../../store/PaymentContext";
import { PaymentConst, checkHolidayAndDayOff } from "../../utils/payment";
import { checkHasBundling, prepareDataValidate } from "./util";
import { reportOrderError, validateMoney } from "../../pages/api/cart";
import AppContext from "../../store/AppContext";
import { notification, Spin } from "antd";
import { useRouter } from "next/router";
import toast from "react-hot-toast";
import moment from "moment";
import { refreshStocking } from "./TableProduct";

interface IProps {
    setLoading: Function | any
}
const TotalCart: React.FC<IProps> = ({ setLoading }) => {
    const router = useRouter();
    const iAppContext = useContext(AppContext);
    const [api, contextHolder] = notification.useNotification();

    const {
        tabActiveStep1,
        setTabActiveStep1,
        setCurrentStep,
        rentTotal,
        sellTotal,

        rentCustomerApply,
        sellCustomerApply,

        setRentCustomerError,
        setSellCustomerError,

        rentCustomer,
        sellCustomer,

        setRentCustomer,
        setSellCustomer,

        rentCarts,
        sellCarts,

        sellAdditionalInformation,
        rentAdditionalInformation,

        rentDepositFee,
        rentTransportFee,
        rentSurchargeFee,

        sellTransportFee,

        discountFee,

        customer,
        isMobile,
        setSellCarts,
        setRentCarts
    }: any = useContext(PaymentContext);
    const handle = async () => {
        try {
            let cloneSellCarts = await refreshStocking(true, sellCarts, () => { });
            let cloneRentCarts = await refreshStocking(true, rentCarts, () => { });

            if (cloneSellCarts === null || cloneRentCarts === null) {
                api.error({
                    message: `Thông báo`,
                    description: 'Lỗi hệ thống',
                    duration: 5,
                });
                return;
            }
            await handleNextStepPayment(cloneRentCarts, cloneSellCarts);
            await setSellCarts(cloneSellCarts);
            await setRentCarts(cloneRentCarts);

        } catch (error) {

        }
    }

    const handleNextStepPayment = async (rentCarts: any, sellCarts: any) => {
        await setLoading(true);


        try {
            let isErrorQty: boolean = true;
            let isError: boolean = false;
            let errRent: any = {}
            let errSell: any = {}

            /** Check qty */
            if (rentCarts?.length > 0) {
                rentCarts.forEach((el: any) => {
                    if (el.qty === 0 && el.checked === true) {
                        isErrorQty = false
                    }
                    el?.accessories?.forEach((acc: any) => {
                        if (acc.qty === 0 && acc.checked === true && el.is_product === true) {
                            isErrorQty = false
                        }
                    })
                });
            }
            if (sellCarts?.length > 0) {
                //console.log('sellCarts', sellCarts);

                sellCarts.forEach((el: any) => {


                    if (el.qty === 0 && el.checked === true) {
                        //console.log("el1", el);
                        isErrorQty = false
                    }
                    el?.accessories?.forEach((acc: any) => {
                        if (acc.qty === 0 && acc.checked === true && el.is_product === true) {
                            //console.log("acc1", acc);
                            isErrorQty = false
                        }
                    })
                });
            }

            if (!isErrorQty) {
                api.warning({
                    message: `Thông báo`,
                    description: 'Vui lòng nhập số lượng khác 0',
                    duration: 5,
                });
                await setLoading(false);
                return;
            }

            /** Check rent customer */
            //Edit: Check set lẻ
            let cloneRentCarts = rentCarts.filter((item: any) => {
                if (item.checked == true && !item.allowed_split) {
                    return true
                }
                if (item.allowed_split) {
                    return true
                }
                return false
            });
            let cloneSellCarts = sellCarts.filter((item: any) => {
                if (item.checked == true && !item.allowed_split) {
                    return true
                }
                if (item.allowed_split) {
                    return true
                }
                return false
            });
            cloneRentCarts = checkHasBundling(cloneRentCarts);
            cloneSellCarts = checkHasBundling(cloneSellCarts);
            //console.log("cloneRentCarts", cloneRentCarts);
            const lstIgnore = ['note', 'birthday', 'sex'];
            let validatePhone = /^0\(?(\d{2})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
            if (cloneRentCarts?.length > 0) {
                if (rentCarts?.length > 0) {
                    let cloneRentCustomer = { ...rentCustomer };
                    if (sellCustomerApply) {
                        cloneRentCustomer = { ...sellCustomer };
                        setRentCustomer(cloneRentCustomer);
                    }

                    

                    for (let p in cloneRentCustomer) {
                //         let validatePhone = /^0\(?(\d{2})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
                // if (!validatePhone.test(value)) {
                //     setErrors({
                //         ...errors,
                //         [key]: 'Số điện thoại không hợp lệ',
                //     })
                //     return;
                // }
                        if (p == 'phone') {
                            if (!validatePhone.test(cloneRentCustomer[p])) {
                                errRent[p] = `${PaymentConst.LabelCustomer[p]} không hợp lệ`;
                                isError = true;
                            }
                        }
                        if (!cloneRentCustomer[p] && !lstIgnore.includes(p)) {
                            errRent[p] = `${PaymentConst.LabelCustomer[p]} không được bỏ trống`;

                            isError = true;
                        }
                    }

                    let old_take_date = null;
                    let old_return_date = null;

                    for (let index = 0; index < rentCarts.length; index++) {
                        const item = rentCarts[index];



                        if ((!item.take_date || !item?.return_date) && item.checked) {
                            toast.error(`Thời gian thuê của sản phẩm ${item.name} không được bỏ trống`)

                            let sameIds = rentCarts.filter((v: any, i: any) => rentCarts.find((e: any, index: number) => e.id === v.id && i !== index && e.checked === true));

                            if (sameIds.length > 1) {
                                api.warning({
                                    message: `Thông báo`,
                                    description: 'Không thể thanh toán đơn khác ngày thuê',
                                    duration: 5,
                                });
                                await setLoading(false);
                                return;
                            }



                            for (let p in cloneRentCustomer) {
                                if (!cloneRentCustomer[p] && !lstIgnore.includes(p)) {
                                    errRent[p] = `${PaymentConst.LabelCustomer[p]} không được bỏ trống`;
                                    isError = true;
                                }


                            }


                            await setLoading(false);
                            return;
                        } else {
                            if (item.checked === true) {
                                let take_date = new Date(item.take_date);
                                let current_date = new Date();
                                take_date.setHours(0, 0, 0, 0);
                                current_date.setHours(0, 0, 0, 0);

                                if (take_date < current_date) {
                                    api.warning({
                                        message: `Thông báo`,
                                        description: 'Ngày thuê nhỏ hơn ngày hiện tại. Vui lòng chọn ngày khác',
                                        duration: 5,
                                    });
                                    await setLoading(false);
                                    return;
                                }

                                let status = checkHolidayAndDayOff(iAppContext.workingDay, iAppContext.holidays, item);
                                if (status !== 0 && !item.is_purchase) {
                                    // api.warning({
                                    //     message: `Thông báo`,
                                    //     description: 'Ngày trả trùng với ngày nghỉ của cửa hàng. Vui lòng chọn ngày khác',
                                    //     duration: 5,
                                    // });
                                    if (status === 1) {
                                        api.warning({
                                            message: `Thông báo`,
                                            description: 'Ngày trả trùng với ngày nghỉ của cửa hàng. Vui lòng chọn ngày khác',
                                            duration: 5,
                                        });
                                    } else if (status === 2) {
                                        api.warning({
                                            message: `Thông báo`,
                                            description: 'Ngày trả trùng với ngày nghỉ của cửa hàng. Vui lòng chọn ngày khác',
                                            duration: 5,
                                        });
                                    } else if (status === 4) {
                                        api.warning({
                                            message: `Thông báo`,
                                            description: 'Ngày thuê trùng với ngày nghỉ của cửa hàng. Vui lòng chọn ngày khác',
                                            duration: 5,
                                        });
                                    } else {
                                        api.warning({
                                            message: `Thông báo`,
                                            description: 'Ngày thuê trùng với ngày nghỉ của cửa hàng. Vui lòng chọn ngày khác',
                                            duration: 5,
                                        });
                                    }
                                    await setLoading(false);
                                    return;
                                }
                            }
                        }

                        if (!old_take_date && !old_return_date && item.checked) {
                            old_take_date = item.take_date;
                            old_return_date = item.return_date;
                        } else {
                            //console.log("item", item);

                            if ((moment(old_take_date).format("DD/MM/YYYY") != moment(item.take_date).format("DD/MM/YYYY") || moment(old_return_date).format("DD/MM/YYYY") != moment(item.return_date).format("DD/MM/YYYY")) && item.checked == true) {
                                api.warning({
                                    message: `Thông báo`,
                                    description: 'Không thể thanh toán đơn khác ngày thuê',
                                    duration: 5,
                                });
                                await setLoading(false);
                                return;
                            }
                        }

                        if (
                            rentAdditionalInformation.delivery_type === PaymentConst.DeliveryType.pickupDirectly
                            && !rentAdditionalInformation.branch_id
                        ) {
                            errRent.branch_id = `Vui lòng chọn chi nhánh lấy hàng`
                            isError = true;
                        }
                    }
                }
            }

            /** check sell customer */

            if (cloneSellCarts?.length > 0) {
                let cloneSellCustomer = { ...sellCustomer };
                if (rentCustomerApply) {
                    cloneSellCustomer = { ...rentCustomer };
                    setSellCustomer(cloneSellCustomer);
                }

                // const lstIgnore = ['note', 'birthday', 'sex'];

                for (let p in cloneSellCustomer) {
                    if (p == 'phone') {
                        if (!validatePhone.test(cloneSellCustomer[p])) {
                            errRent[p] = `${PaymentConst.LabelCustomer[p]} không hợp lệ`;
                            isError = true;
                        }
                    }
                    if (!cloneSellCustomer[p] && !lstIgnore.includes(p)) {
                        errSell[p] = `${PaymentConst.LabelCustomer[p]} không được bỏ trống`;
                        isError = true;
                    }
                }
            }

            if (
                sellAdditionalInformation.delivery_type === PaymentConst.DeliveryType.pickupDirectly
                && !sellAdditionalInformation.branch_id
            ) {
                setSellCustomerError((pre: any) => ({
                    ...pre,
                    branch_id: `Vui lòng chọn chi nhánh lấy hàng`
                }));
            }

            if (
                sellAdditionalInformation.delivery_type === PaymentConst.DeliveryType.pickupDirectly
                && !sellAdditionalInformation.branch_id
            ) {
                errSell.branch_id = `Vui lòng chọn chi nhánh lấy hàng`
                isError = true;
            }

            //check quá tồn kho
            //console.log('cloneSellCarts', cloneSellCarts);

            cloneSellCarts?.map((e: any) => {
                if (e.qty > e.amount && e.checked && e.accessories?.length === e.temp_accessories?.length) {
                    api.warning({
                        message: `Đơn bán`,
                        description: `Sản phẩm ${e.name} vượt quá số lượng tồn kho là ${e.amount}`,
                        duration: 5,
                    });
                    setLoading(false);
                    isError = false;
                    return;
                }
                let checkedSet: any = [];
                e.accessories?.map((acc: any) => {
                    if (e.is_product !== false) {
                        if (acc.qty > acc.amount && acc.checked) {
                            api.warning({
                                message: `Đơn bán`,
                                description: `Sản phẩm ${e.name} vượt quá số lượng tồn kho là ${e.amount}`,
                                duration: 5,
                            });
                            setLoading(false);
                            isError = false;
                            return;
                        }
                    }
                    if (acc.checked && !acc.bundling_id) {
                        checkedSet = [
                            ...checkedSet,
                            acc
                        ]
                    }


                    if (acc.checked && acc.bundling_id) {
                        //console.log("Inn", acc);

                        if (checkedSet.length !== e.set_qty) {
                            api.warning({
                                message: `Đơn bán`,
                                description: `Sản phẩm ${acc.name} phải đặt kèm với tất cả sản phẩm của ${e.name}`,
                                duration: 5,
                            });
                            setLoading(false);
                            isError = true;
                            return;
                        }

                        if (acc.maximum_order && acc.qty > acc.maximum_order) {
                            api.warning({
                                message: `Đơn bán`,
                                description: `Sản phẩm ${acc.name} vượt quá số lượng tối đa đặt hàng là ${acc.maximum_order}`,
                                duration: 5,
                            });
                            setLoading(false);
                            isError = true;
                            return;
                        }
                    }
                })
                return e;
            })

            cloneRentCarts?.map((e: any) => {
                if (e.qty > e.amount && e.checked && e.accessories?.length === e.temp_accessories?.length) {
                    api.warning({
                        message: `Đơn thuê`,
                        description: `Sản phẩm ${e.name} vượt quá số lượng tồn kho là ${e.amount}`,
                        duration: 5,
                    });
                    setLoading(false);
                    isError = false;
                    return;
                }
                let checkedSet: any = [];
                e.accessories?.map((acc: any) => {
                    if (acc.checked && !acc.bundling_id) {
                        checkedSet = [
                            ...checkedSet,
                            acc
                        ]
                    }
                    if (e.is_product !== false) {
                        if (acc.qty > acc.amount && acc.checked) {
                            api.warning({
                                message: `Đơn thuê`,
                                description: `Sản phẩm ${acc.name} vượt quá số lượng tồn kho là ${acc.amount}`,
                                duration: 5,
                            });
                            setLoading(false);
                            isError = false;
                            return;
                        }
                    }


                    if (acc.checked && acc.bundling_id) {
                        //console.log("Inn payment", acc);
                        if (checkedSet.length !== e.set_qty) {
                            api.warning({
                                message: `Đơn thuê`,
                                description: `Sản phẩm ${acc.name} phải đặt kèm với tất cả sản phẩm của ${e.name}`,
                                duration: 5,
                            });
                            setLoading(false);
                            isError = true;
                            return;
                        }

                        if (acc.maximum_order && acc.qty > acc.maximum_order) {
                            api.error({
                                message: `Đơn thuê`,
                                description: `Sản phẩm ${acc.name} vượt quá số lượng tối đa đặt hàng là ${acc.maximum_order}`,
                                duration: 5,
                            });
                            setLoading(false);
                            isError = true;
                            return;
                        }
                    }
                })
                return e;
            })


            if (!isError) {
                const checkData: any = {
                    purchase_prod: prepareDataValidate(iAppContext.workingDay, iAppContext.holidays, cloneSellCarts, iAppContext.generalSetting, true),
                    rent_prod: prepareDataValidate(iAppContext.workingDay, iAppContext.holidays, cloneRentCarts, iAppContext.generalSetting, true),
                }
                //console.log("checkData", cloneSellCarts, cloneRentCarts);

                if (checkData?.purchase_prod?.length === 0 && checkData?.rent_prod?.length === 0) {
                    api.warning({
                        message: `Thông báo`,
                        description: 'Vui lòng chọn sản phẩm',
                        duration: 5,
                    });
                    setLoading(false);
                    return;
                }

                let response = await validateMoney(checkData);
                // console.log("response", response);
                // console.log("discountFee", discountFee);
                // console.log('rentDepositFee', rentDepositFee);
                // console.log('rentSurchargeFee', rentSurchargeFee);
                // console.log("rentTotal", rentTotal);
                // console.log("sellTotal", sellTotal);

                if (
                    response?.discount !== discountFee
                    || response?.insurance_money !== rentDepositFee
                    || response?.surcharge !== rentSurchargeFee
                    || response?.total_rent_order !== rentTotal
                    || response?.total_purchase_order !== sellTotal
                    || response?.total_order !== (rentTotal + sellTotal)
                ) {
                    await reportOrderError(customer)

                    api.warning({
                        message: `Thông báo`,
                        description: 'Có lỗi xảy ra khi tạo đơn hàng, vui lòng tạo lại sau',
                        duration: 5,
                    });
                    await setLoading(false);
                    return;
                } else {
                    setCurrentStep(2)
                    if (router.pathname === '/checkout') {
                        return router.push('/order-success');
                    }
                    return router.push('/checkout')
                }
            } else {
                let isSet = false;
                if (Object.keys(errRent).length > 0 && rentCarts.length) {
                    if (tabActiveStep1 !== PaymentConst.TabConst.rent) {
                        isSet = true;
                        setTabActiveStep1(PaymentConst.TabConst.rent);
                    }
                    setRentCustomerError(errRent);
                }

                if (Object.keys(errSell).length > 0 && sellCarts.length) {
                    if (tabActiveStep1 !== PaymentConst.TabConst.buy && !isSet) {
                        setTabActiveStep1(PaymentConst.TabConst.buy);
                    }
                    setSellCustomerError(errSell);
                }
            }

        } catch (err) {
            console.log("err", err);
            await setLoading(false);
            throw err;
        }

        await setLoading(false);
    }

    return (
        <div className={`${isMobile ? 'fixed w-full ' : 'sticky '} bottom-0 z-[100]`} style={{ height: '7.5rem' }}>
            {contextHolder}
            <div className="flex z-[100] justify-center bg-white border-t md:rounded-bl-lg md:rounded-br-lg">
                <div className="grid grid-cols-2 gap-4 cart__total-amount">
                    <div className="flex flex-col justify-center gap-1">
                        <Heading4 className="total_payment bold text-lg">Tổng cộng giỏ hàng</Heading4>
                        <div>Mua: <strong className="color-danger">
                            {currencyFormatter.format(sellTotal + sellTransportFee)}
                        </strong></div>
                        <div>Thuê: <strong className="color-danger">
                            {currencyFormatter.format(rentTotal + rentSurchargeFee + rentTransportFee + rentDepositFee)}</strong>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:gap-2 py-2 items-center">
                        <ButtonPrimaryOutline className="cart_btn-footer-payment" onClick={() => router.push('/')}>Trở về mua sắm</ButtonPrimaryOutline>
                        <ButtonPrimary className="cart_btn-footer-payment" onClick={handle}>Thanh toán</ButtonPrimary>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TotalCart
